import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
//System
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import Loader from "@/components/widgets/loader.vue";
Component.registerHooks(["metaInfo"]);
let UIElements = /** @class */ (() => {
    let UIElements = class UIElements extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            //data
            this.title = "UI Elements";
            this.pageIsLoading = true;
            //private scrollToTop: any;
            this.items = [
                {
                    text: "Extras",
                },
                {
                    text: "UI Elements",
                    active: true
                },
            ];
        }
        getScrollToTop() {
            window.scrollTo({
                left: 0,
                top: 0,
                behavior: 'smooth'
            });
        }
        mounted() {
            setTimeout(() => {
                this.pageIsLoading = false;
            }, 100);
        }
    };
    UIElements = __decorate([
        Component({
            name: "UIElements",
            components: {
                Loader,
                PageHeader,
                Layout
            },
        })
    ], UIElements);
    return UIElements;
})();
export default UIElements;
